import React, { useEffect, useState } from "react";
import Navbar from "../../components/client/Navbar";
import AccountCard from "../../components/client/AccountCard";
import NotificationsCard from "../../components/client/NotificationsCard";
import CreditsCard from "../../components/client/CreditsCard";
import ResourceUsage from "../../components/client/ResourceUsage";
import PromoCarousel from "../../components/client/QuickActions";
import InstancesTable from "../../components/client/InstancesTable";
import axiosInstance from "../../api/axiosInstance";

export default function Home() {
    const [instances, setInstances] = useState([]);
    const [limits, setLimits] = useState({
        cpu: { used: 0, limit: 1 },
        ram: { used: 0, limit: 1 },
        storage: { used: 0, limit: 1 },
    });

    useEffect(() => {
        let retryCount = 0;
        const maxRetries = 6;
        const fetchInstances = async () => {
            try {
                const res = await axiosInstance.get("/os/instances/");
                if (res.data && res.data.length > 0) {
                    setInstances(res.data);
                } else if (retryCount < maxRetries) {
                    retryCount++;
                    setTimeout(fetchInstances, 2000);
                } else {
                    setInstances([]);
                }
            } catch (error) {
                console.error("Failed to fetch instances", error);
            }
        };
        fetchInstances();
    }, []);

    useEffect(() => {
        const fetchLimits = async () => {
            try {
                const res = await axiosInstance.get("/overview/limits/");
                setLimits(res.data);
            } catch (error) {
                console.error("Failed to fetch resource limits", error);
            }
        };
        fetchLimits();
    }, []);

    return (
        <div className="min-h-screen  text-gray-900 dark:bg-dark-gradient dark:text-gray-100">
            <Navbar credits={150} />
            <div className="container mx-auto px-4 mt-10 md:mt-10">
                {/* Dashboard content */}
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 md:gap-4 mb-4">
                    <AccountCard />
                    <NotificationsCard />
                    <CreditsCard />
                </div>
                <div className="flex flex-col gap-4 md:grid md:grid-cols-7">
                    <div className="col-span-7 md:col-span-4">
                        <ResourceUsage limits={limits} />
                    </div>
                    <div className="col-span-7 md:col-span-3">
                        <PromoCarousel />
                    </div>
                </div>
                <InstancesTable instances={instances} />
            </div>
        </div>
    );
}
